function MaintenanceServiceAlerts({ alerts = [] }) {
    if (!alerts.length) {
        return (
            <div className="alert alert-success mx-3 mb-3">
                No preventive maintenance alerts — all tracked equipment is within due limits.
            </div>
        );
    }

    return (
        <div className="mx-3 mb-3">
            <div className="alert alert-warning mb-2">
                <strong>{alerts.length} service alert(s)</strong> — review due date / hour meter limits below.
            </div>
            <div className="table-responsive">
                <table className="table table-sm table-bordered bg-white">
                    <thead>
                        <tr>
                            <th>Level</th>
                            <th>Equipment</th>
                            <th>Service</th>
                            <th>Due Date</th>
                            <th>Due HM</th>
                            <th>Current HM</th>
                            <th>Reason</th>
                        </tr>
                    </thead>
                    <tbody>
                        {alerts.map((row) => (
                            <tr key={row.id} className={row.alert_level === 'OVERDUE' ? 'table-danger' : 'table-warning'}>
                                <td>{row.alert_level === 'OVERDUE' ? 'Overdue' : 'Due Soon'}</td>
                                <td>{row.equipment_name}</td>
                                <td>{row.service_type_label || row.service_type}</td>
                                <td>{row.next_service_due_date || '—'}</td>
                                <td>{row.next_service_due_hm || '—'}</td>
                                <td>{row.current_hm}</td>
                                <td>{(row.alert_reasons || []).join('; ')}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default MaintenanceServiceAlerts;
